import { KeyboardEvent } from 'react';
import { Controller } from 'react-hook-form';
import { Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { InputSelect, Label, MultiSelectGroup } from '~/commonComponents';
import { expectedDaysOptions, scheduleTypeOptions } from '~/components/PermanentJobsV2/utils';
import { IBaseFormProps } from '../../Types';

export const ScheduleForm = ({ control, errors }: IBaseFormProps) => {
  const allCodes = expectedDaysOptions.map((option) => option.code);

  return (
    <Column gapY={6} gapX={4} direction="row">
      <Column gap={2} className="min-w-[226px]">
        <Label text="Schedule Type" required />
        <Controller
          control={control}
          name="scheduleType"
          render={({ field }) => (
            <InputSelect
              placeholder="Select Schedule Type"
              value={field.value}
              setValue={field.onChange}
              isSelectVisible={false}
              options={scheduleTypeOptions.map((option) => ({
                title: option.name,
                value: option.code,
              }))}
              error={!!errors?.scheduleType}
              dataCy="perm-schedule-type-select"
            />
          )}
        />
      </Column>

      <Column className="flex-1">
        <Controller
          control={control}
          name="expectedDays"
          render={({ field }) => (
            <Column gap={2}>
              <Row justify="between">
                <Label text="Expected Days" required={false} />
                <Typography
                  as="span"
                  bold
                  color={colors.secondary[500]}
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                  onClick={() => field.onChange(allCodes)}
                  onKeyDown={(e: KeyboardEvent) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      field.onChange(allCodes);
                    }
                  }}
                >
                  Select All
                </Typography>
              </Row>
              <MultiSelectGroup
                noWrapOptions
                variant="pill"
                value={field.value}
                options={expectedDaysOptions.map((option) => ({
                  value: option.code,
                  label: option.name[0].toUpperCase(),
                }))}
                onChange={(selected) => field.onChange(selected.map((s) => s.value))}
              />
            </Column>
          )}
        />
      </Column>
    </Column>
  );
};
